import React from 'react';
import { connect } from 'react-redux';
import { selectHasMultipleNonPinnedVariables } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { TextInputControlProps } from '../TextInputControl';
import { TextInputControlWindow } from './TextInputControlWindow';
import { TextInputControlWindowBody } from './TextInputControlWindowBody';

const _TextInputControlMobile = ({ hasMultipleNonPinnedVariables, isContentFirst, ...props }: Props) => {
    if (hasMultipleNonPinnedVariables || isContentFirst) {
        return (
            <TextInputControlWindow {...props} isContentFirst={isContentFirst} />
        );
    } else {
        return (
            <TextInputControlWindowBody {...props} />
        );
    }
};

type Props = TextInputControlProps & {
    hasMultipleNonPinnedVariables: boolean;
};

const mapStateToProps = (state: GiftPdpState) => ({
    hasMultipleNonPinnedVariables: selectHasMultipleNonPinnedVariables(state)
});

export const TextInputControlMobile = connect(
    mapStateToProps
)(_TextInputControlMobile);